import { FC } from "react";
import { BrowserRouter, MemoryRouter } from "react-router-dom";
import { EBuildType } from "./types.app";
const buildType = process.env.REACT_APP_BUILD_TYPE as EBuildType;
export const Router: FC = ({ children }) => {
  if (buildType === EBuildType.ELECTRON) return <MemoryRouter>{children}</MemoryRouter>;
  return <BrowserRouter>{children}</BrowserRouter>;
};
